import { Service } from '../service.js';
import { env } from '../env.js';

class AnexoService extends Service {
    constructor() {
        super();
        this.url = env.url + "anexo-historico-tarefas";
    }

    async visualizarById(id,type) {
        const url = `${this.url}/visualizar/${id}`;
        return super.visualizarFile(url,type);
    }

    async obterAnexos(historicoId, faseId, atendimentoId) {
        const url = `${this.url}/obter-anexos`;
        const queryString = faseId ? `faseHistoricoTarefaWebId=${faseId}` : `historicoTarefaWebId=${historicoId}`;
        const atendimentoParam = atendimentoId ? `&atendimentoId=${atendimentoId}` : '';
        return super.get(`${url}?${queryString}${atendimentoParam}`);
    }

    async incluirAnexos(historicoId, faseId, anexos) {
        const url = `${this.url}/incluir-anexos`;
        const dto = {
            historicoTarefaId: historicoId,
            faseHistoricoTarefaWebId: faseId || null,
            anexos
        }
        return super.post(url, dto);
    }

    async excluirAnexo(anexo) {
        const url = `${this.url}/excluir-anexos`;
        return super.delete(url, anexo);
    }
}

export const anexoService = new AnexoService()